<form class="f-col blank-form" [formGroup]="companySettingForm">
  <div class="section-heading">
    <h2 class="h2-heading">
      {{content?.['b2b.managecompany.omfcompanysettings']}}
      <div class="dot">.</div>
      <span class="optional"> {{content?.['b2b.managecompany.optional']}}</span>
    </h2>
  </div>
  <div class="section-content">
    <!-- Approval & Policy -->
    <div class="inner-contentsection" formGroupName="approvalAndPolicy">
      <mat-accordion class="mat-accordion cam_accordion">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h4 class="subheading">{{content?.['b2b.managecompany.omfapprovalandpolicy']}}</h4>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mat-panel-body-custom">

            <div class="info-section-wrapper">
              <div class="f-row">
                <div class="f-row">
                    <div class="f-col validation-col border-0">
                    <mat-slide-toggle formControlName="enableMailToReportingManager">{{content?.['b2b.managecompany.omfenableitinerarymail'] || 'Send itinerary to reporting manager'}}</mat-slide-toggle>
                    </div>
                </div>
                <div class="f-row">
                    <div class="f-col validation-col border-0">
                    <mat-slide-toggle formControlName="enableGoOnLeave">{{content?.['b2b.managecompany.allowgoonleave'] || 'Allow Go on Leave'}}</mat-slide-toggle>
                    </div>
                </div>
              </div>
            </div>

          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Bookings -->
    <div class="inner-contentsection" formGroupName="bookings">
      <mat-accordion class="mat-accordion cam_accordion">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h4 class="subheading">{{content?.['b2b.managecompany.omfbookings']}}</h4>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-panel-body-custom">

            <div class="info-section-wrapper">

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="allowAutoTicketToSBT">{{content?.['b2b.managecompany.allowpaynow'] || 'Allow Pay Now to Employees'}} </mat-slide-toggle>
                </div>
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enableManualCardEntry">{{content?.['b2b.managecompany.allownonsavedcards'] || 'Allow Non-Saved Cards'}}</mat-slide-toggle>
                </div>
              </div>

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enableMultiPassengerSearch">{{ content?.['b2b.managecompany.allowmultipassengersearch'] || 'Enable multi-passenger search' }}</mat-slide-toggle>
                </div>
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enableGuestSearch">{{ content?.['b2b.managecompany.allowguestsearch'] || 'Allow Guest Bookings' }}</mat-slide-toggle>
                </div>
              </div>

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="allowRebookingEmployees">{{ content?.['b2b.managecompany.allowrebookingemployee'] || 'Allow Rebooking for Employees' }}</mat-slide-toggle>
                </div>
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="allowCancellationEmployee">{{ content?.['b2b.managecompany.allowcancellationemployee'] || 'Allow Cancellation for Employees' }}</mat-slide-toggle>
                </div>
              </div>

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="allowRebookingTA">{{ content?.['b2b.managecompany.allowrebookingtravelarranger'] || 'Allow Rebooking for Travel Arranger' }}</mat-slide-toggle>
                </div>
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="allowCancellationTA">{{content?.['b2b.managecompany.allowcancellationtravelarranger'] || 'Allow Cancellation for Travel Arranger'}}</mat-slide-toggle>
                </div>
              </div>
            </div>

          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Extras -->
    <div class="inner-contentsection" formGroupName="extras">
      <mat-accordion class="mat-accordion cam_accordion">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h4 class="subheading">{{content?.['b2b.managecompany.omfextras']}}</h4>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mat-panel-body-custom">

            <div class="info-section-wrapper">

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enableSeatMap">{{content?.['b2b.managecompany.allowseatmap'] || 'Allow Seat Map'}}</mat-slide-toggle>
                </div>
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enablePaidSeatMap">{{content?.['b2b.managecompany.allowpaidseatmap'] || 'Allow Paid Seat Map'}}</mat-slide-toggle>
                </div>
              </div>

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enablePaidMeal">{{content?.['b2b.managecompany.omfshowpaidmeal']}}</mat-slide-toggle>
                </div>
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enablePaidBaggage">{{content?.['b2b.managecompany.omfshowpaidbaggage']}}</mat-slide-toggle>
                </div>
              </div>

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enableFastTrack">{{content?.['b2b.managecompany.allowfasttrack'] || 'Allow Fast Track'}}</mat-slide-toggle>
                </div>
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enableLoungePass">{{content?.['b2b.managecompany.allowloungepass'] || 'Allow Lounge Pass'}}</mat-slide-toggle>
                </div>
              </div>

              <div class="f-row two--colLayout">
                <div class="f-col validation-col border-0">
                  <mat-slide-toggle formControlName="enableMeetAndGreet">{{content?.['b2b.managecompany.allowmeetgreet'] || 'Allow Meet and Greet'}}</mat-slide-toggle>
                </div>
              </div>

            </div>

          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="inner-action">
      <button mat-button class="button--secondary-small" [class.disabled]="buttonDisable" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
      <button mat-button class="button--primary-small" [class.disabled]="buttonDisable" (click)="onSave()">{{content?.['b2b.managecompany.save']}}</button>
    </div>
  </div>
</form>